import { Button, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import CardContainer from "../../../../commons/cards/CardContainer";
import DatosDelEstablecimientoCard from "../../../../commons/establecimiento/DatosDelEstablecimientoCard";
import { StyledRgrl } from "../../../../styled/Prevencion";

const EstablecimientoForm = ({ searchedRgrl, nextForm }) => {

  const datosEstablecimiento = useSelector(
    (state) => state.rgrl.datosEstablecimiento
  );

  const requerirActividadDecretos = useSelector(
    (state) => state.rgrl.requerirActividadDecretos
  );
  const validarDisponibilidadCargaRGRL = useSelector(
    (state) => state.rgrl.validarDisponibilidadCargaRgrl
  );

  const handleSubmit = () => {
    nextForm("Decreto");
  };

  // no dejamos que el usuario continue si se cumple
  // alguno de los siguientes casos:
  // 1. hay error con el servidor
  // (porque no vamos a tener los datos del establecimiento para el resto de los formularios)
  // 2. el usuario no buscó ningun establecimiento (misma razon que 1.)
  // 3. el establecimiento ya tiene un formulario RGRL en curso
  // (esto es por especificacion del analista)
  // 4. Hubo error al buscar el parametro que indica si tiene actividades o se configura el decreto directamente
  const noPuedeContinuarCargaRgrl =
    validarDisponibilidadCargaRGRL.loading || requerirActividadDecretos.loading || requerirActividadDecretos.error || !datosEstablecimiento.data?.nombre ||
      !searchedRgrl ||
      validarDisponibilidadCargaRGRL?.error
      ? true
      : false;

  return (
    <>
      <StyledRgrl.PaddingContainer container spacing={2}>
        {searchedRgrl ? (
          <>
            <StyledRgrl.FlexDirectionColumn item xs={12}>
              <CardContainer
                title="Datos del Establecimiento"
                loading={datosEstablecimiento.loading}
                componente={
                  <DatosDelEstablecimientoCard
                    data={datosEstablecimiento.data}
                  />
                }
                getData={() => { }}
              />
            </StyledRgrl.FlexDirectionColumn>
          </>
        ) : (
          <StyledRgrl.LoadingContainer
            item
            xs={12}
            style={{ height: 300 }}
          >
            <Typography
              style={{
                padding: "150px 20px 200px 50px",
                color: "grey",
                textAlign: "center",
              }}
            >
              Busque un establecimiento.
            </Typography>
          </StyledRgrl.LoadingContainer>
        )}
      </StyledRgrl.PaddingContainer>
      <StyledRgrl.ButtonContainer>
        <Button
          color="primary"
          variant="contained"
          onClick={handleSubmit}
          disabled={noPuedeContinuarCargaRgrl || validarDisponibilidadCargaRGRL.loading}
        >
          SIGUIENTE
        </Button>
      </StyledRgrl.ButtonContainer>
    </>
  );
};

export default EstablecimientoForm;
